import React from 'react';
export function PainSection() {
  return <section className="py-20 px-5 text-center bg-cream reveal" data-id="element-155">
      <h2 className="font-playfair text-[clamp(1.8rem,3.5vw,2.6rem)] font-bold text-text-dark mb-3.5 leading-[1.2]" data-id="element-156">
        El dolor que muchas mamás
        <br data-id="element-157" />
        viven en silencio
      </h2>
      <p className="font-lora text-base text-text-mid max-w-[500px] mx-auto mb-10 leading-relaxed italic" data-id="element-158">
        Ver a tu hijo sufrir frente a un libro es una de las experiencias más
        difíciles de la maternidad. No es solo lectura. Es su autoestima.
      </p>

      <div className="max-w-[560px] mx-auto flex flex-col bg-white rounded-xl border border-black/5 overflow-hidden shadow-[0_4px_24px_rgba(30,45,36,0.06)]" data-id="element-159">
        <div className="flex items-start gap-3.5 py-[18px] px-6 border-b border-black/5 text-left text-[0.95rem] text-text-mid leading-relaxed" data-id="element-160">
          <span className="text-[#C0392B] text-base shrink-0 mt-0.5" data-id="element-161">⚠️</span>
          <span data-id="element-162">Se compara constantemente con sus compañeros</span>
        </div>
        <div className="flex items-start gap-3.5 py-[18px] px-6 border-b border-black/5 text-left text-[0.95rem] text-text-mid leading-relaxed" data-id="element-163">
          <span className="text-[#C0392B] text-base shrink-0 mt-0.5" data-id="element-164">⚠️</span>
          <span data-id="element-165">Evita participar en clase por miedo a equivocarse</span>
        </div>
        <div className="flex items-start gap-3.5 py-[18px] px-6 border-b border-black/5 text-left text-[0.95rem] text-text-mid leading-relaxed" data-id="element-166">
          <span className="text-[#C0392B] text-base shrink-0 mt-0.5" data-id="element-167">⚠️</span>
          <span data-id="element-168">Su seguridad baja cada día que pasa sin avanzar</span>
        </div>
        <div className="flex items-start gap-3.5 py-[18px] px-6 text-left text-[0.95rem] leading-relaxed bg-[#FEF5F3] border-l-4 border-l-[#C0392B]" data-id="element-169">
          <span className="text-[#C0392B] text-base shrink-0 mt-0.5" data-id="element-170">⚠️</span>
          <span className="text-text-dark" data-id="element-171">
            <strong className="text-[#C0392B]" data-id="element-172">"No soy inteligente."</strong> —
            Lo que tu hijo empieza a creer sobre sí mismo.
          </span>
        </div>
      </div>
    </section>;
}